<div class="dialog-container">

  <!-- Header -->
  <div class="dialog-header">
    <span class="dialog-title">Novo item de logística</span>
    <div class="flex items-center gap-3">
      <mat-slide-toggle [(ngModel)]="isEmergencial" name="isEmergencial" color="warn">
        Modo Emergencial
      </mat-slide-toggle>
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Tabs -->
  <mat-tab-group animationDuration="0ms" class="flex-1 overflow-hidden flex flex-col">

    <!-- ══════════════════════════════════════════════════════ PASSAGEIROS ══ -->
    <mat-tab label="Passageiros">
      <div class="tab-content">

        <!-- Seção Emergencial -->
        @if (isEmergencial) {
          <div class="section-card" style="border-left:4px solid #ef4444;margin-bottom:16px;">
            <div class="section-card-header">
              <span class="section-title" style="color:#ef4444">Dados Emergenciais</span>
              <button mat-button class="btn-tg" (click)="criarItemEmergencial()" [disabled]="savingItem">
                @if (savingItem) { Salvando... } @else { Criar Item Emergencial }
              </button>
            </div>
            <div class="form-grid">
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo Trecho</mat-label>
                <mat-select [(ngModel)]="trechoForm.tipoTrechoId" name="emTipoTrecho">
                  @for (st of stretchTypes; track st.id) {
                    <mat-option [value]="st.id">{{ st.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo Veículo</mat-label>
                <mat-select [(ngModel)]="trechoForm.tipoVeiculoId" name="emTipoVeiculo">
                  @for (vt of vehicleTypes; track vt.id) {
                    <mat-option [value]="vt.id">{{ vt.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo Motorista</mat-label>
                <mat-select [(ngModel)]="trechoForm.tipoMotoristaId" name="emTipoMotorista">
                  @for (dt of driverTypes; track dt.id) {
                    <mat-option [value]="dt.id">{{ dt.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Data Início</mat-label>
                <input matInput type="date" [(ngModel)]="trechoForm.dataInicio" name="emDataInicio" (ngModelChange)="checkEmergencial()" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Data Fim</mat-label>
                <input matInput type="date" [(ngModel)]="trechoForm.dataFim" name="emDataFim" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Hora Saída</mat-label>
                <input matInput type="time" [(ngModel)]="trechoForm.horaSaida" name="emHoraSaida" (ngModelChange)="checkEmergencial()" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Hora Prevista</mat-label>
                <input matInput type="time" [(ngModel)]="trechoForm.horaPrevista" name="emHoraPrevista" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Km Previsto</mat-label>
                <input matInput type="number" [(ngModel)]="trechoForm.kmPrevisto" name="emKm" min="0" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Custo Emergencial</mat-label>
                <span matTextPrefix>R$&nbsp;</span>
                <input matInput type="number" step="0.01" min="0"
                       [(ngModel)]="custoEmergencial" name="emCusto" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg" style="grid-column: 1 / -1">
                <mat-label>Observação</mat-label>
                <textarea matInput [(ngModel)]="trechoForm.observacao" name="emObservacao" rows="2"></textarea>
              </mat-form-field>
            </div>

            <!-- Itinerários -->
            <div class="section-card-header" style="margin-top:12px;">
              <span class="section-title">Itinerários</span>
              <button mat-button class="btn-tg" (click)="openAddItinerario()">Adicionar</button>
            </div>

            @if (itinerarios.length > 0) {
              <div class="table-wrapper" style="margin-top:8px;">
                <table mat-table [dataSource]="itinerarios" class="iti-table">
                  <ng-container matColumnDef="local">
                    <th mat-header-cell *matHeaderCellDef>Local</th>
                    <td mat-cell *matCellDef="let iti">{{ iti.local || '-' }}</td>
                  </ng-container>
                  <ng-container matColumnDef="cidade">
                    <th mat-header-cell *matHeaderCellDef>Cidade</th>
                    <td mat-cell *matCellDef="let iti">{{ iti.cidade || '-' }}</td>
                  </ng-container>
                  <ng-container matColumnDef="trecho">
                    <th mat-header-cell *matHeaderCellDef>Trecho</th>
                    <td mat-cell *matCellDef="let iti">{{ iti.trecho === 'O' ? 'Origem' : iti.trecho === 'D' ? 'Destino' : '-' }}</td>
                  </ng-container>
                  <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let iti; let i = index">
                      <button class="btn-icon" (click)="editItinerario(i)" matTooltip="Editar">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button class="btn-icon" (click)="removeItinerario(i)" matTooltip="Remover">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="itinerarioColumnsEmergencial"></tr>
                  <tr mat-row *matRowDef="let row; columns: itinerarioColumnsEmergencial;"></tr>
                </table>
              </div>
            }

            @if (showItinerarioForm) {
              <div class="iti-form" style="margin-top:8px;">
                <div class="iti-form-grid">
                  <mat-form-field appearance="outline" class="input-tg">
                    <mat-label>Local</mat-label>
                    <input matInput [(ngModel)]="itinerarioForm.local" name="itiLocal" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-tg">
                    <mat-label>CEP</mat-label>
                    <input matInput [(ngModel)]="itinerarioForm.cep" name="itiCep" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-tg">
                    <mat-label>Logradouro</mat-label>
                    <input matInput [(ngModel)]="itinerarioForm.logradouro" name="itiLogradouro" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-tg">
                    <mat-label>Número</mat-label>
                    <input matInput [(ngModel)]="itinerarioForm.numero" name="itiNumero" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-tg">
                    <mat-label>Bairro</mat-label>
                    <input matInput [(ngModel)]="itinerarioForm.bairro" name="itiBairro" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-tg">
                    <mat-label>Cidade</mat-label>
                    <input matInput [(ngModel)]="itinerarioForm.cidade" name="itiCidade" />
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="input-tg">
                    <mat-label>Trecho</mat-label>
                    <mat-select [(ngModel)]="itinerarioForm.trecho" name="itiTrecho">
                      <mat-option value="O">Origem</mat-option>
                      <mat-option value="D">Destino</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="iti-form-actions">
                  <button mat-button class="btn-tg" (click)="cancelItinerario()">Cancelar</button>
                  <button mat-button class="btn-tg" (click)="saveItinerario()">Salvar</button>
                </div>
              </div>
            }
          </div>
        }

        <!-- Agrupamento -->
        <div class="agrupamento-card">
          <span class="agrupamento-title">Agrupamento</span>
          <div class="agrupamento-fields">

            <mat-form-field appearance="outline" class="agrup-field">
              <mat-label>Por</mat-label>
              <mat-select [(ngModel)]="groupBy" (selectionChange)="applyGrouping()">
                <mat-option value="aeroporto">Aeroporto</mat-option>
                <mat-option value="endereco">Endereço</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="agrup-field">
              <mat-label>Sentido</mat-label>
              <mat-select [(ngModel)]="sentido" (selectionChange)="applyGrouping()">
                <mat-option value="ambos">Ambos</mat-option>
                <mat-option value="origem">Origem</mat-option>
                <mat-option value="destino">Destino</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="agrup-field">
              <mat-label>Data</mat-label>
              <mat-select [(ngModel)]="groupByDate" (selectionChange)="applyGrouping()">
                <mat-option [value]="true">Sim</mat-option>
                <mat-option [value]="false">Não</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="agrup-field agrup-field-sm">
              <mat-label>Hora</mat-label>
              <input matInput type="number" [(ngModel)]="toleranceMinutes" (change)="applyGrouping()" min="1" max="120" />
            </mat-form-field>

          </div>

          @if (selectedCount > 0) {
            <div class="selected-badge">
              <mat-icon class="badge-check-icon">check_circle</mat-icon>
              {{ selectedCount }} selecionado(s)
              <mat-icon class="badge-clear-icon" (click)="clearSelection()" matTooltip="Limpar seleção">close</mat-icon>
            </div>
          }
        </div>

        @if (loadingPassengers) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }

        <!-- Groups -->
        <div class="groups-container">

          @if (!loadingPassengers && passengerGroups.length === 0) {
            <div class="empty-state">
              <mat-icon>group_off</mat-icon>
              <p>Nenhum passageiro encontrado.</p>
            </div>
          }

          <mat-accordion multi>
            @for (group of passengerGroups; track group.label) {
              <mat-expansion-panel [expanded]="group.expanded" class="group-panel">

                <mat-expansion-panel-header>
                  <span class="group-label">{{ group.label }}</span>
                </mat-expansion-panel-header>

                <div class="table-wrapper">
                  <table mat-table [dataSource]="group.passengers" class="passenger-table">

                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let p">
                        <mat-checkbox [checked]="isSelected(p)" (change)="togglePassenger(p)"></mat-checkbox>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="nome">
                      <th mat-header-cell *matHeaderCellDef>Nome</th>
                      <td mat-cell *matCellDef="let p">{{ p.nome }}</td>
                    </ng-container>

                    <ng-container matColumnDef="documento">
                      <th mat-header-cell *matHeaderCellDef>Documento</th>
                      <td mat-cell *matCellDef="let p">{{ p.documento ?? '-' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="trecho">
                      <th mat-header-cell *matHeaderCellDef>Trecho</th>
                      <td mat-cell *matCellDef="let p">
                        {{ p.tipoTrechoDescricao ?? p.tipo_trecho_descricao ?? '-' }}
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="cia">
                      <th mat-header-cell *matHeaderCellDef>CIA</th>
                      <td mat-cell *matCellDef="let p">{{ p.companhia ?? '-' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="hora">
                      <th mat-header-cell *matHeaderCellDef>Hora</th>
                      <td mat-cell *matCellDef="let p">
                        <div class="hora-cell">
                          <mat-icon class="btn-icon-outline flight-icon">flight_takeoff</mat-icon>
                          <span>{{ p.hora ?? '-' }}</span>
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="voo">
                      <th mat-header-cell *matHeaderCellDef>Voo</th>
                      <td mat-cell *matCellDef="let p">
                        <div class="voo-cell">
                          <span>{{ p.voo ?? p.numeroVoo ?? '-' }}</span>
                          @if ((p.voo ?? p.numeroVoo)) {
                            <mat-icon
                              class="btn-icon-outline"
                              matTooltip="Acessar dados do voo"
                              (click)="abrirVoo(p.voo ?? p.numeroVoo)">connecting_airports</mat-icon>
                          }
                        </div>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="acoes">
                      <th mat-header-cell *matHeaderCellDef>Ações</th>
                      <td mat-cell *matCellDef="let p">
                        <div class="flex justify-end items-center gap-3">
                          <mat-icon
                            class="btn-icon-outline"
                            fontIcon="edit"
                            matTooltip="Editar"
                            (click)="editPassenger(p)"
                          />
                        </div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="passengerColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: passengerColumns;"
                      [ngClass]="getRowClass(row)"
                      [class.row-selected]="isSelected(row)">
                    </tr>
                  </table>
                </div>

              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>

      </div>
    </mat-tab>

     ═════════════════════════════════════════════════ ITENS PROPOSTA ══
    <mat-tab label="Itens Proposta">
      <div class="tab-content tab-content-scroll">

        <!-- ── Informações do trecho ── -->
        <div class="section-card">
          <div class="section-card-header">
            <span class="section-title">Informações do trecho</span>
            <button mat-raised-button class="btn-tg" (click)="criarItem()" [disabled]="savingItem">
              @if (savingItem) { <span>Salvando...</span> } @else { <span>Criar Item</span> }
            </button>
          </div>

          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Data Início *</mat-label>
              <input matInput type="date" [(ngModel)]="trechoForm.dataInicio" (ngModelChange)="checkEmergencial()" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Data Fim *</mat-label>
              <input matInput type="date" [(ngModel)]="trechoForm.dataFim" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Hora Saída *</mat-label>
              <input matInput type="time" [(ngModel)]="trechoForm.horaSaida" (ngModelChange)="checkEmergencial()" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Hora Prevista</mat-label>
              <input matInput type="time" [(ngModel)]="trechoForm.horaPrevista" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tempo Previsto</mat-label>
              <input matInput type="time" [(ngModel)]="trechoForm.tempoPrevisto" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tipo trecho</mat-label>
              <mat-select [(ngModel)]="trechoForm.tipoTrechoId">
                @for (st of stretchTypes; track st.id) {
                  <mat-option [value]="st.id">{{ st.descricao }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Km - Previsto *</mat-label>
              <input matInput type="number" [(ngModel)]="trechoForm.kmPrevisto" min="0" />
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-full-width">
              <mat-label>Observação</mat-label>
              <textarea matInput [(ngModel)]="trechoForm.observacao" rows="3"></textarea>
            </mat-form-field>
          </div>
        </div>

        <!-- ── Itinerários ── -->
        <div class="section-card">
          <div class="section-card-header">
            <span class="section-title">Itinerários</span>
            <div class="section-actions">
              <button mat-stroked-button class="btn-tg-outline" disabled>
                Calcular Itinerário
              </button>
              <button mat-raised-button class="btn-tg" (click)="openAddItinerario()">
                ADICIONAR
              </button>
            </div>
          </div>

          <!-- Itinerary table -->
          @if (itinerarios.length > 0) {
            <div class="table-wrapper">
              <table mat-table [dataSource]="itinerarios" class="iti-table">

                <ng-container matColumnDef="local">
                  <th mat-header-cell *matHeaderCellDef>Local</th>
                  <td mat-cell *matCellDef="let iti">{{ iti.local || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="cep">
                  <th mat-header-cell *matHeaderCellDef>CEP</th>
                  <td mat-cell *matCellDef="let iti">{{ iti.cep || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="logradouro">
                  <th mat-header-cell *matHeaderCellDef>Logradouro</th>
                  <td mat-cell *matCellDef="let iti">{{ iti.logradouro || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="numero">
                  <th mat-header-cell *matHeaderCellDef>Número</th>
                  <td mat-cell *matCellDef="let iti">{{ iti.numero || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="bairro">
                  <th mat-header-cell *matHeaderCellDef>Bairro</th>
                  <td mat-cell *matCellDef="let iti">{{ iti.bairro || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="cidade">
                  <th mat-header-cell *matHeaderCellDef>Cidade</th>
                  <td mat-cell *matCellDef="let iti">{{ iti.cidade || '-' }}</td>
                </ng-container>

                <ng-container matColumnDef="areaTarifaria">
                  <th mat-header-cell *matHeaderCellDef>Área Tarifária</th>
                  <td mat-cell *matCellDef="let iti">{{ iti.areaTarifaria }}</td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                  <th mat-header-cell *matHeaderCellDef>Ações</th>
                  <td mat-cell *matCellDef="let iti; let i = index">
                    <button mat-icon-button (click)="editItinerario(i)" matTooltip="Editar">
                      <mat-icon style="color:#f97316;font-size:18px;width:18px;height:18px;">edit</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeItinerario(i)" matTooltip="Remover">
                      <mat-icon style="color:#ef4444;font-size:18px;width:18px;height:18px;">delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="itinerarioColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: itinerarioColumns;"></tr>
              </table>
            </div>
          }

          <!-- Inline itinerary form -->
          @if (showItinerarioForm) {
            <div class="iti-form">
              <div class="iti-form-grid">
                <mat-form-field appearance="outline">
                  <mat-label>Local</mat-label>
                  <input matInput [(ngModel)]="itinerarioForm.local" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>CEP</mat-label>
                  <input matInput [(ngModel)]="itinerarioForm.cep" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Logradouro</mat-label>
                  <input matInput [(ngModel)]="itinerarioForm.logradouro" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Número</mat-label>
                  <input matInput [(ngModel)]="itinerarioForm.numero" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Bairro</mat-label>
                  <input matInput [(ngModel)]="itinerarioForm.bairro" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Cidade</mat-label>
                  <input matInput [(ngModel)]="itinerarioForm.cidade" />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Área Tarifária</mat-label>
                  <mat-select [(ngModel)]="itinerarioForm.areaTarifaria">
                    <mat-option value="Dentro">Dentro</mat-option>
                    <mat-option value="Fora">Fora</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="iti-form-actions">
                <button mat-button (click)="cancelItinerario()">Cancelar</button>
                <button mat-raised-button class="btn-tg" (click)="saveItinerario()">Salvar</button>
              </div>
            </div>
          }
        </div>

        <!-- ── Itens Proposta (search) ── -->
        <div class="section-card">
          <span class="section-title">Itens Proposta</span>

          <!-- Search card -->
          <div class="search-card">
            <span class="search-title">Pesquisa</span>
            <div class="search-grid">
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Cidade Origem</mat-label>
                <input matInput [(ngModel)]="proposalSearch.origemCidade" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Estado Origem</mat-label>
                <input matInput [(ngModel)]="proposalSearch.origemEstado" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Cidade Destino</mat-label>
                <input matInput [(ngModel)]="proposalSearch.destinoCidade" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Estado Destino</mat-label>
                <input matInput [(ngModel)]="proposalSearch.destinoEstado" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Pax</mat-label>
                <input matInput type="number" [(ngModel)]="proposalSearch.pax" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo Serviço</mat-label>
                <input matInput [(ngModel)]="proposalSearch.descricaoTipoServico" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Serviço</mat-label>
                <input matInput [(ngModel)]="proposalSearch.descricaoServico" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo Veículo</mat-label>
                <mat-select [(ngModel)]="proposalSearch.tipoVeiculoId">
                  <mat-option [value]="null">Todos</mat-option>
                  @for (vt of vehicleTypes; track vt.id) {
                    <mat-option [value]="vt.id">{{ vt.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo Motorista</mat-label>
                <mat-select [(ngModel)]="proposalSearch.tipoMotoristaId">
                  <mat-option [value]="null">Todos</mat-option>
                  @for (dt of driverTypes; track dt.id) {
                    <mat-option [value]="dt.id">{{ dt.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Tipo Trecho</mat-label>
                <mat-select [(ngModel)]="proposalSearch.tipoTrechoId">
                  <mat-option [value]="null">Todos</mat-option>
                  @for (st of stretchTypes; track st.id) {
                    <mat-option [value]="st.id">{{ st.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Data Início</mat-label>
                <input matInput type="date" [(ngModel)]="proposalSearch.dataInicio" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="input-tg">
                <mat-label>Data Final</mat-label>
                <input matInput type="date" [(ngModel)]="proposalSearch.dataFinal" />
              </mat-form-field>
            </div>
            <div class="mb-3 flex justify-end items-center gap-2">
              <button class="btn-icon" (click)="resetProposalSearch()" [matTooltip]="'Limpar Pesquisa'"><mat-icon>replay</mat-icon></button>
              <button class="btn-icon" (click)="searchProposalItems()" [matTooltip]="'Pesquisar'"><mat-icon>search</mat-icon></button>
            </div>
          </div>

          <!-- Sort + Add -->
          <div class="results-toolbar">
            <div class="sort-group">
              <span class="filter-label">Ordenação</span>
              <mat-form-field appearance="outline" class="filter-field">
                <mat-select [(ngModel)]="proposalOrderBy" (selectionChange)="fetchProposalItems()">
                  @for (s of proposalSorts; track s.id) {
                    <mat-option [value]="s.id">{{ s.description }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <button mat-raised-button class="btn-add-novo" (click)="openAddProposalItem()">
              Adicionar Novo
            </button>
          </div>

          @if (loadingProposalItems) {
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          }

          <!-- Results table -->
          <table-list-os
            [dataSource]="proposalItems"
            [columns]="proposalTableColumns"
            (selectItem)="selectProposalItem($event)"
          />

          @if (proposalItems.length > 0) {
            <mat-paginator
              [length]="proposalTotalRows"
              [pageSize]="proposalRows"
              [pageSizeOptions]="[10, 25, 50]"
              (page)="onProposalPageEvent($event)">
            </mat-paginator>
          }


        </div>

      </div>
    </mat-tab>

     ════════════════════════════════════════════════ ITENS LOGÍSTICA ══
    <mat-tab label="Itens Logística">
      <div class="tab-content tab-content-scroll">

        <!-- Header: contagem + botão Salvar Todos -->
        <div class="flex justify-between items-center mb-3" style="flex-shrink:0">
          <span class="text-sm text-gray-500">{{ contractItems.length }} item(s) na fila</span>
          <button mat-raised-button class="btn-save-all"
            (click)="saveAllItems()"
            [disabled]="savingItem || contractItems.length === 0">
            @if (savingItem) { Salvando... } @else { Salvar Todos ({{ contractItems.length }}) }
          </button>
        </div>

        <div style="flex:1;overflow-y:auto">
          @for (item of contractItems; track item.localId) {
            <div class="ci-card">
              <!-- Linha 1: resumo + ações -->
              <div class="ci-header">
                <span><strong>Tipo:</strong> {{ item.display.tipoServico }}</span>
                <span><strong>Serviço:</strong> {{ item.display.servico }}</span>
                <span><strong>Veículo:</strong> {{ item.display.veiculo }}</span>
                <span><strong>Motorista:</strong> {{ item.display.motorista }}</span>
                <span><strong>Valor:</strong> R$ {{ item.display.valor | number:'1.2-2' }}</span>
                <div class="ci-actions">
                  <button mat-icon-button (click)="deleteContractItem(item)" matTooltip="Remover da fila">
                    <mat-icon style="color:#ef4444;font-size:18px;width:18px;height:18px">delete</mat-icon>
                  </button>
                </div>
              </div>
              <!-- Linha 2: detalhes -->
              <div class="ci-details">
                <div class="ci-location">
                  <strong>Origem</strong>
                  <span>Cidade: {{ item.display.cidadeOrigem }}</span>
                  <span>Estado: {{ item.display.estadoOrigem }}</span>
                </div>
                <div class="ci-location">
                  <strong>Destino</strong>
                  <span>Cidade: {{ item.display.cidadeDestino }}</span>
                  <span>Estado: {{ item.display.estadoDestino }}</span>
                </div>
                <div class="ci-times">
                  <span><strong>Início:</strong> {{ item.display.dataInicio }} - {{ item.display.horaInicio }}</span>
                  <span><strong>Fim prevista:</strong> {{ item.display.dataFinal }} - {{ item.display.horaFinal }}</span>
                </div>
                <span><strong>Tipo trecho:</strong> {{ item.display.tipoTrechoDescricao }}</span>
                <span><strong>Pax:</strong> {{ item.display.pax }}</span>
              </div>
            </div>
          }

          @if (contractItems.length === 0) {
            <div class="empty-state">
              <mat-icon>playlist_add</mat-icon>
              <p>Nenhum item na fila. Selecione um item de proposta e clique em "Criar Item".</p>
            </div>
          }
        </div>

      </div>
    </mat-tab>

    <!-- ════════════════════════════════════════════════════ VALIDAÇÃO ══ -->
<!--    <mat-tab label="Validação">-->
<!--      <div class="tab-content tab-content-scroll">-->

<!--        <div class="flex justify-between items-center mb-3" style="flex-shrink:0">-->
<!--          <span class="section-title">Validação Logística</span>-->
<!--          <button mat-raised-button class="btn-tg" (click)="loadValidacao()" [disabled]="loadingValidacao">-->
<!--            @if (loadingValidacao) { Carregando... } @else { Verificar }-->
<!--          </button>-->
<!--        </div>-->

<!--        @if (loadingValidacao) {-->
<!--          <mat-progress-bar mode="indeterminate"></mat-progress-bar>-->
<!--        }-->

<!--        @if (!loadingValidacao && validacao === null && !validacaoError) {-->
<!--          <div class="empty-state">-->
<!--            <mat-icon>rule</mat-icon>-->
<!--            <p>Clique em "Verificar" para checar as discrepâncias logísticas deste contrato.</p>-->
<!--          </div>-->
<!--        }-->

<!--        @if (validacaoError) {-->
<!--          <div class="empty-state">-->
<!--            <mat-icon style="color:#ef4444">error_outline</mat-icon>-->
<!--            <p>Não foi possível carregar a validação. Tente novamente.</p>-->
<!--          </div>-->
<!--        }-->

<!--        @if (validacao) {-->
<!--          &lt;!&ndash; Discrepâncias de Quantidade &ndash;&gt;-->
<!--          <div class="section-card">-->
<!--            <span class="section-title">-->
<!--              Discrepâncias de Quantidade-->
<!--              @if ((validacao.discrepanciasQuantidade?.length ?? 0) === 0) {-->
<!--                <span class="badge-green" style="margin-left:8px;font-size:12px;">OK</span>-->
<!--              } @else {-->
<!--                <span class="badge-red" style="margin-left:8px;font-size:12px;">-->
<!--                  {{ validacao.discrepanciasQuantidade?.length }} problema(s)-->
<!--                </span>-->
<!--              }-->
<!--            </span>-->

<!--            @if ((validacao.discrepanciasQuantidade?.length ?? 0) > 0) {-->
<!--              <div class="table-wrapper">-->
<!--                <table mat-table [dataSource]="validacao.discrepanciasQuantidade" class="passenger-table">-->

<!--                  @for (col of validacaoQuantidadeCols; track col) {-->
<!--                    <ng-container [matColumnDef]="col">-->
<!--                      <th mat-header-cell *matHeaderCellDef>{{ col }}</th>-->
<!--                      <td mat-cell *matCellDef="let row">{{ row[col] ?? '-' }}</td>-->
<!--                    </ng-container>-->
<!--                  }-->

<!--                  <tr mat-header-row *matHeaderRowDef="validacaoQuantidadeCols"></tr>-->
<!--                  <tr mat-row *matRowDef="let row; columns: validacaoQuantidadeCols"></tr>-->
<!--                </table>-->
<!--              </div>-->
<!--            } @else {-->
<!--              <p class="text-sm text-gray-400 mt-2">Nenhuma discrepância de quantidade encontrada.</p>-->
<!--            }-->
<!--          </div>-->

<!--          &lt;!&ndash; Discrepâncias de Trecho &ndash;&gt;-->
<!--          <div class="section-card">-->
<!--            <span class="section-title">-->
<!--              Discrepâncias de Trecho-->
<!--              @if ((validacao.discrepanciasTrecho?.length ?? 0) === 0) {-->
<!--                <span class="badge-green" style="margin-left:8px;font-size:12px;">OK</span>-->
<!--              } @else {-->
<!--                <span class="badge-red" style="margin-left:8px;font-size:12px;">-->
<!--                  {{ validacao.discrepanciasTrecho?.length }} problema(s)-->
<!--                </span>-->
<!--              }-->
<!--            </span>-->

<!--            @if ((validacao.discrepanciasTrecho?.length ?? 0) > 0) {-->
<!--              <div class="table-wrapper">-->
<!--                <table mat-table [dataSource]="validacao.discrepanciasTrecho" class="passenger-table">-->

<!--                  @for (col of validacaoTrechoCols; track col) {-->
<!--                    <ng-container [matColumnDef]="col">-->
<!--                      <th mat-header-cell *matHeaderCellDef>{{ col }}</th>-->
<!--                      <td mat-cell *matCellDef="let row">{{ row[col] ?? '-' }}</td>-->
<!--                    </ng-container>-->
<!--                  }-->

<!--                  <tr mat-header-row *matHeaderRowDef="validacaoTrechoCols"></tr>-->
<!--                  <tr mat-row *matRowDef="let row; columns: validacaoTrechoCols"></tr>-->
<!--                </table>-->
<!--              </div>-->
<!--            } @else {-->
<!--              <p class="text-sm text-gray-400 mt-2">Nenhuma discrepância de trecho encontrada.</p>-->
<!--            }-->
<!--          </div>-->
<!--        }-->

<!--      </div>-->
<!--    </mat-tab>-->

  </mat-tab-group>

</div>
